import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"

/** Renders an animated plus minus icon. */
const AnimatedPlusMinus = ({
  open,
  styleOverride = {}
}) => (
  <span key="base" style={[styles.base]} data-test={open ? "open" : "closed"}>
    <span key="1" style={[styles.line, styles.firstLine(open), styleOverride]} />
    <span key="2" style={[styles.line, styles.secondLine(open), styleOverride]} />
  </span>
)

AnimatedPlusMinus.propTypes = {
  open: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  styleOverride: PropTypes.object
}

export default Radium(AnimatedPlusMinus)

const styles = {
  base: {
    display: "inline-block",
    position: "relative",
    verticalAlign: "middle",
    flexShrink: 0,
    top: "-3px",
    width: "1em"
  },
  firstLine: active => ({
    transform: active ? "rotate(180deg)" : "rotate(90deg)",
    background: active ? "#910A2D" : "currentColor"
  }),
  secondLine: active => ({
    transform: active && "rotate(180deg)",
    background: active ? "#910A2D" : "currentColor"
  }),
  line: {
    transition: "transform .15s linear .15s, background .15s ease .25s",
    position: "absolute",
    top: "50%",
    transformOrigin: "center center",
    display: "inline",
    verticalAlign: "middle",
    height: "2px",
    width: "100%"
  }
}



// WEBPACK FOOTER //
// ./src/containers/animated-plus-minus/index.jsx